import { Component, Inject, OnInit } from '@angular/core';
import { GruppeTier } from '../../classes/gruppe-tier';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'kiene-gruppe-tier-betriebskontakt-haendler-zuordnen-dialog',
    templateUrl: './gruppe-tier-betriebskontakt-haendler-zuordnen-dialog.component.html',
    styleUrls: ['./gruppe-tier-betriebskontakt-haendler-zuordnen-dialog.component.scss'],
})
export class GruppeTierBetriebskontaktHaendlerZuordnenDialogComponent implements OnInit {
    tier: GruppeTier;

    constructor(
        public dialogRef: MatDialogRef<GruppeTierBetriebskontaktHaendlerZuordnenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.tier = data.tier;
    }

    ngOnInit(): void {}

    onSaved(tier: GruppeTier): void {
        // Dialog automatisch schließen nach erfolgreichem Speichern
        this.dialogRef.close(tier);
    }
}
